import React, { useState, useEffect } from "react";

const MessageA23 = (props) => {
//   const [value, setValue] = useState(-1);
  const [onSelect , setOnSelect] = useState(false)
  useEffect(()=>{
      props.setisSubscriber(false)
  })
  

  const listData = JSON.parse(props.item.text); 

  return (
    <div style={{ width: "fit-content" , margin : '6px',cursor: 'pointer' }} >
      {listData.data &&
        listData.data.map((data) => (
          <>
            <button
           className={
                !onSelect
                  ? "chat-label action-tab "
                  : "chat-label-select action-tab"
              }
              id="main-tab1"
              style={{ color: data.disabled && "grey" }}
              onClick={(e) => {
                props?.addMessages(null ,props?.item?.code ,props?.item?.text)
                // props.setTextOnClick(data.name);
                setOnSelect(true)
              }}
            >
              {data.name}
            </button>
          </>
        ))}{" "}
    </div>
  );
};

export default MessageA23;


